import React from 'react';
import { TrendingUp, Code2, Layers, Users, Database, Lightbulb, BarChart, ArrowRight, BookOpen, ShieldCheck, FileCode, HelpCircle, Image as ImageIcon, GitMerge, Monitor, Cpu } from 'lucide-react';
export function InvestorsSection() {
  const points = [{
    title: 'Marktomvang',
    desc: '600.000+ leerlingen doelgroep in groep 6-8. Uitbreidbaar naar groep 3-5.',
    icon: <TrendingUp className="w-5 h-5" data-id="element-117" />
  }, {
    title: 'Curriculum-aligned',
    desc: 'Volledig afgestemd op het Nederlandse basisonderwijs. CITO-aligned.',
    icon: <BookOpen className="w-5 h-5" data-id="element-118" />
  }, {
    title: 'Technische Diepgang',
    desc: 'Client-side architectuur, modulaire engines (Zustand state), JSON seeds.',
    icon: <Code2 className="w-5 h-5" data-id="element-119" />
  }, {
    title: 'Schaalbaar Platform',
    desc: 'Lage server-overhead, voorbereid op snelle uitbreiding van content.',
    icon: <Layers className="w-5 h-5" data-id="element-120" />
  }, {
    title: 'Multi-stakeholder',
    desc: 'Vier gebruikersrollen (leerling, ouder, leraar, admin) in één ecosysteem.',
    icon: <Users className="w-5 h-5" data-id="element-121" />
  }, {
    title: 'Content Engine',
    desc: '100+ skill-families. Geautomatiseerde kwaliteitscontrole via pipeline.',
    icon: <Database className="w-5 h-5" data-id="element-122" />
  }, {
    title: 'Didactische Innovatie',
    desc: 'Distractor-specifieke feedback en cognitieve niveaubepaling per vraag.',
    icon: <Lightbulb className="w-5 h-5" data-id="element-123" />
  }, {
    title: 'Data-gedreven',
    desc: 'Gedetailleerde leerlingprofielen en groei-indicatoren voor alle partijen.',
    icon: <BarChart className="w-5 h-5" data-id="element-124" />
  }];
  const stats = [{
    value: '10',
    label: 'Vakgebieden'
  }, {
    value: '16',
    label: 'Niveaus'
  }, {
    value: '17+',
    label: 'Vraagtypes'
  }, {
    value: '100+',
    label: 'Skills'
  }, {
    value: '15+',
    label: 'Visuele hulpmiddelen'
  }, {
    value: '6',
    label: 'Staps pipeline'
  }, {
    value: '4',
    label: 'Gebruikersrollen'
  }, {
    value: '4',
    label: 'Leermodi'
  }];
  const pipelineSteps = [{
    name: 'Schema Validatie',
    icon: <FileCode className="w-4 h-4" data-id="element-125" />
  }, {
    name: 'Vraagtype Check',
    icon: <HelpCircle className="w-4 h-4" data-id="element-126" />
  }, {
    name: 'Didactische Inhoud',
    icon: <BookOpen className="w-4 h-4" data-id="element-127" />
  }, {
    name: 'Visuele Support',
    icon: <ImageIcon className="w-4 h-4" data-id="element-128" />
  }, {
    name: 'Hints & Feedback',
    icon: <Lightbulb className="w-4 h-4" data-id="element-129" />
  }, {
    name: 'Leerpad Integriteit',
    icon: <GitMerge className="w-4 h-4" data-id="element-130" />
  }];
  const architectureLayers = [{
    title: 'Laag 1 — Gebruikersinterface',
    icon: <Monitor className="w-4 h-4" data-id="element-131" />,
    items: ['HomePage', 'Learning Lab', 'Oefensessies', 'Toetsen', 'Voortgang', 'Portalen'],
    color: 'text-blue-400'
  }, {
    title: 'Laag 2 — Kern Engines',
    icon: <Cpu className="w-4 h-4" data-id="element-132" />,
    items: ['Adaptive Engine', 'Mastery Engine', 'Assessment Engine', 'Mode Engine', 'Placement Engine'],
    color: 'text-indigo-400'
  }, {
    title: 'Laag 3 — Data & Governance',
    icon: <Database className="w-4 h-4" data-id="element-133" />,
    items: ['Taxonomy Registry', 'Question Loader', 'Seed Consolidator', '6-Stage Pipeline', 'Visual Registry', 'LDG'],
    color: 'text-purple-400'
  }];
  const techBadges = ['React', 'TypeScript', 'Tailwind CSS', 'Framer Motion', 'LocalStorage'];
  return <section id="investeerders" className="py-16 lg:py-24 bg-slate-950 text-slate-300" data-id="element-134">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="max-w-3xl mb-16" data-id="element-136">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-6 tracking-tighter" data-id="element-137">
            Klaar voor de toekomst van EdTech.
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed" data-id="element-138">
            Een robuuste architectuur, een schaalbaar content-model en een
            enorme marktpotentie. Ontdek waarom Meester djay de volgende stap in
            adaptief leren is.
          </p>
        </div>

        {/* Big Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20 pb-12 border-b border-slate-800" data-id="element-139">
          {stats.map((stat, idx) => <div key={idx} data-id="element-140">
              <div className="text-4xl md:text-5xl font-extrabold text-white mb-2 tracking-tighter" data-id="element-141">
                {stat.value}
              </div>
              <div className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-142">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* Investment Points Grid */}
        <div className="grid md:grid-cols-2 gap-x-16 gap-y-10 mb-20" data-id="element-143">
          {points.map((point, idx) => <div key={idx} className="flex gap-4" data-id="element-144">
              <div className="text-orange-400 shrink-0 mt-1" data-id="element-145">{point.icon}</div>
              <div data-id="element-146">
                <h3 className="text-base font-bold text-white mb-2" data-id="element-147">
                  {point.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed" data-id="element-148">
                  {point.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="grid lg:grid-cols-2 gap-16 mb-16" data-id="element-149">
          {/* Governance Pipeline Subsection */}
          <div data-id="element-150">
            <div className="flex items-center gap-3 mb-4" data-id="element-151">
              <ShieldCheck className="w-6 h-6 text-orange-400" data-id="element-152" />
              <h3 className="text-xl font-bold text-white" data-id="element-153">
                6-Stage Kwaliteitspipeline
              </h3>
            </div>
            <p className="text-sm text-slate-400 mb-8 leading-relaxed" data-id="element-154">
              Elke vraag doorloopt een streng geautomatiseerd proces. Vragen die
              niet door alle 6 filters komen, worden automatisch geblokkeerd
              voor leerlingen.
            </p>
            <div className="flex flex-wrap gap-3" data-id="element-155">
              {pipelineSteps.map((step, index) => <div key={index} className="flex items-center gap-2 bg-slate-900 border border-slate-800 rounded-full px-4 py-2" data-id="element-156">
                  <span className="text-slate-500" data-id="element-157">{step.icon}</span>
                  <span className="text-xs font-bold text-slate-300" data-id="element-158">
                    {step.name}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Architecture Subsection */}
          <div data-id="element-159">
            <div className="flex items-center gap-3 mb-4" data-id="element-160">
              <Code2 className="w-6 h-6 text-purple-400" data-id="element-161" />
              <h3 className="text-xl font-bold text-white" data-id="element-162">
                Technische Architectuur
              </h3>
            </div>
            <p className="text-sm text-slate-400 mb-8 leading-relaxed" data-id="element-163">
              Een modulaire, client-side architectuur ontworpen voor snelheid,
              privacy en schaalbaarheid.
            </p>
            <div className="space-y-4 mb-8" data-id="element-164">
              {architectureLayers.map((layer, idx) => <div key={idx} className="flex flex-col sm:flex-row sm:items-start gap-4" data-id="element-165">
                  <div className="flex items-center gap-3 min-w-[220px]" data-id="element-166">
                    <span className={layer.color} data-id="element-167">{layer.icon}</span>
                    <h4 className="text-sm font-bold text-white" data-id="element-168">
                      {layer.title}
                    </h4>
                  </div>
                  <div className="flex flex-wrap gap-x-2 gap-y-1" data-id="element-169">
                    {layer.items.map((item, iIdx) => <span key={iIdx} className="text-xs text-slate-400" data-id="element-170">
                        {item}
                        {iIdx < layer.items.length - 1 ? ',' : ''}
                      </span>)}
                  </div>
                </div>)}
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-171">
              {techBadges.map((badge, idx) => <span key={idx} className="px-3 py-1.5 rounded-full bg-slate-800 text-slate-300 text-xs font-bold" data-id="element-172">
                  {badge}
                </span>)}
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-slate-800" data-id="element-173">
          <a href="mailto:contact@meesterdjay.nl" className="inline-flex items-center gap-2 bg-white text-slate-950 hover:bg-slate-100 px-6 py-3 rounded-lg font-bold text-sm transition-colors" data-id="element-174">
            Neem contact op
            <ArrowRight className="w-4 h-4" data-id="element-175" />
          </a>
        </div>
      </div>
    </section>;
}